import script from "./modal-new-configuration.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-new-configuration.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__